export const getContents = ({ sectionId, contentType }) => {
  const url = `/api/section/${sectionId}/${contentType}/contents`;
  return url;
};

export const getAnotherContent = () => {};
